<template>
  <div class="info-item">
    <div class="text-body-1">{{ label }}:</div>
    <div v-if="value" class="text-body-3">{{ value }}</div>
    <div v-else class="text-body-3 text-grey3">N/A</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: String
  }
}
</script>

<style lang="scss" scoped>
.info-item {
  display: contents;
}
</style>
